<template>
  <div
    class="
      waf-component waf-listing
      khabar-listing
      widget-layout-185
      match-tips-listing
    "
    v-if="has_store_data"
  >
    <div class="series_listing_header">
      <Breadcrumbs
        :parentRoute="moduleRoute"
        :currentSeriesObj="getcurrentSeriesObj()"
        :currentSeries="selected_series"
        :sequence="[
          {type: 'base', page: 'home'},
          {type: 'param', param: 'series_slug'},
          {type: 'module', module: moduleRoute}
        ]"
      />
      <div class="filter-select">
        <select-list-custom
          id="series_selection_dd"
          :options="series_list"
          :selected="selected_series"
          :label="'category_name'"
          :identifier="'series_code'"
          :linkKey="'url'"
        />
      </div>
    </div>
    <div class="layout-wrapper">
      <div class="waf-head">
        <h1 class="title">
          {{ sportNameLabel ? `${sportNameLabel}: ` : "" }}{{ translations[pageHeadKey] }}
        </h1>
      </div>
      <div class="page_desc" v-if="pageDescKey">
        <p>{{ getPageDesc() }}</p>
      </div>
      <!-- <gamezy-ad size="mob_small" ad_id="mob_small-ad-1" :autoDetect="true" /> -->
      <!-- <gamezy-ad size="web_small" ad_id="web_small-ad-1" :autoDetect="true" /> -->
      <div
        :class="['article-list', { 'featured-list': !is_mobile_view }]"
        v-if="firstMatch"
      >
        <listing-page-article-htoh-box
          v-if="isHtoh"
          :article="firstMatch"
          :listing_module="listingModules[pageHeadKey]"
          :headline_keys="headlineKeys[pageHeadKey]"
          size="560"
          :isFirstTile="true"
          :showDreamTeamImg="showDreamTeamImg"
          :showVideoImg="showVideoImg"
        />
        <listing-page-article-box
          v-else
          :article="firstMatch"
          :listing_module="listingModules[pageHeadKey]"
          :headline_keys="headlineKeys[pageHeadKey]"
          size="560"
          :isFirstTile="true"
          :showDreamTeamImg="showDreamTeamImg"
          :showVideoImg="showVideoImg"
        />
      </div>
      <div
        v-if="isHtoh"
        id="scrollableWrapper"
        :class="['article-list', { 'related-list': !is_mobile_view }]"
      >
        <listing-page-article-htoh-box
          v-for="(mat, index) in restMatches"
          v-bind:key="(page_number * (index+1))"
          :article="mat"
          :listing_module="listingModules[pageHeadKey]"
          :headline_keys="headlineKeys[pageHeadKey]"
          size="360"
          :isFirstTile="false"
          :showDreamTeamImg="showDreamTeamImg"
          :showVideoImg="showVideoImg"
          :lazyImgType="!firstMatch && index == 0 ? null : 'rect'"
        />
      </div>
      <div
        v-else
        id="scrollableWrapper"
        :class="['article-list', { 'related-list': !is_mobile_view }]"
      >
        <listing-page-article-box
          v-for="(mat, index) in restMatches"
          v-bind:key="(page_number * (index+1))"
          :article="mat"
          :listing_module="listingModules[pageHeadKey]"
          :headline_keys="headlineKeys[pageHeadKey]"
          size="360"
          :isFirstTile="false"
          :showDreamTeamImg="showDreamTeamImg"
          :showVideoImg="showVideoImg"
          :lazyImgType="!firstMatch && index == 0 ? null : 'rect'"
        />
      </div>
      <pagination
        v-if="totalCount > 0"
        :currentPage="page_number"
        :recordsPerView="pagesize"
        :totalRecords="totalCount"
        :baseUrl="getPaginationBaseUrl()"
        :isLoadMoreDisabled="isLoadMoreDisabled"
        :onPageChange="onPageChange"
      />
      <div class="no-contest-section" v-show="no_match_tips_list">
        <div class="no-contest-thumbnail">
          <img
            src="/static-assets/images/cssimages/no-contest-cham.png"
            alt=""
          />
        </div>
        <div class="no-contest-text">
          <p class="text">{{ translations.no_match_tips_list_text_1 }}</p>
          <p class="text">{{ translations.no_match_tips_list_text_2 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  addPagePropertiesToObject,
  cssImport,
  sendTrackingData,
  formatString,
  urlCorrections,
} from "../../assets/js/common";
import { CFG_MODULES, CFG_TRACKING } from "../../assets/js/config";
import SelectListCustom from "../common/SelectListCustom";
import ListingPageArticleBox from "./ListingPageArticleBox";
import ListingPageArticleHtohBox from "./ListingPageArticleHtohBox";
import seriesListModule from "../../store/modules/seriesListing/seriesListing";
import Breadcrumbs from "../common/Breadcrumbs";
import Pagination from "../common/Pagination";
// import GamezyAd from '../common/GamezyAd';
export default {
  props: [
    "pageHeadKey",
    "pageDescKey",
    "showDreamTeamImg",
    "showVideoImg",
    "isHtoh"
  ],
  components: {
    SelectListCustom,
    Breadcrumbs,
    Pagination,
    ListingPageArticleBox,
    ListingPageArticleHtohBox,
    // GamezyAd,
  },
  data() {
    return {
      listingModules: {
        contestMatchesListHeading: CFG_MODULES["GAME_PLAN"],
        lineupMatchesListHeading: CFG_MODULES["LINEUP"],
        matchTipsMatchesListHeading: CFG_MODULES["MATCH_INFO"],
        teamHtohListHeading: CFG_MODULES["TEAM_HTOH"],
        playerHtohListHeading: CFG_MODULES["PLAYER_HTOH"],
      },
      headlineKeys: {
        contestMatchesListHeading: "contests_headline",
        lineupMatchesListHeading: "lineup_headline",
        matchTipsMatchesListHeading: "match_tips_headline",
        teamHtohListHeading: "team_htoh_headline",
        playerHtohListHeading: "player_htoh_headline",
      },
    };
  },
  computed: {
    has_store_data() {
      return !!(
        this.$store.state &&
        this.$store.state.serieslist &&
        this.$store.state.serieslist.listing_store_filled
      );
    },
    translations() {
      return this.$store.state.translations;
    },
    is_mobile_view() {
      return this.$store.state.ismobile;
    },
    firstMatch() {
      return this.$store.state.serieslist.first_match;
    },
    restMatches() {
      return this.$store.state.serieslist.rest_matches;
    },
    page_number: {
      get: function () {
        return this.$store.state.serieslist.pagenumber;
      },
      set: function (newPage) {
        this.$store.state.serieslist.pagenumber = newPage;
      },
    },
    totalCount() {
      return this.$store.state.serieslist.totalCount;
    },
    pagesize() {
      return this.$store.state.serieslist.pagesize;
    },
    isLoadMoreDisabled() {
      return this.$store.state.serieslist.isLoadMoreDisabled;
    },
    no_match_tips_list() {
      return this.$store.state.serieslist.no_match_tips_list;
    },
    sportNameLabel() {
      if (this.selected_series && this.selected_series != -1) {
        let selectedSeries = this.getcurrentSeriesObj();
        let sName = (selectedSeries && selectedSeries.category_name) || "";
        return sName ? sName : "";
      } else {
        let sport = this.$store.state.serieslist.selectedSport;
        return sport ? sport.name : "";
      }
    },
    series_list() {
      let seriesList = this.$store.state.serieslist.series_list;
      if (seriesList && seriesList.length) {
        seriesList.map((s) => {
          s.url = this.getSeriesUrl(s);
        });
      }
      return seriesList;
    },
    selected_series() {
      return this.$store.state.serieslist.selected_series;
    },
    moduleRoute() {
      return (this.listingModules[this.pageHeadKey] && this.listingModules[this.pageHeadKey].route)
    }
  },
  async serverPrefetch() {
    // serverPrefetch runs only on serverside
    this.$store.registerModule("serieslist", seriesListModule);
    await this.$store.dispatch("serieslist/fetchMatchData");
    if(this.isHtoh) {
      return await this.$store.dispatch("serieslist/fetchHtohListing");
    } else {
      return await this.$store.dispatch("serieslist/fetchMatchTipsListing");
    }
  },
  beforeMount() {
    this.registerSeriesListModule();
  },
  mounted() {
    let hasStore = this.has_store_data;
    cssImport(["/static-assets/css/widgets/postlisting/widget-layout-185.css"]);
    if (!hasStore) {
      this.initApis(hasStore);
    }
  },
  methods: {
    async registerSeriesListModule() {
      let hasSeriesListModule = this.$store.hasModule("serieslist");
      if (!hasSeriesListModule) {
        this.$store.registerModule("serieslist", seriesListModule, {
          preserveState: this.has_store_data,
        });
      }
    },
    async initApis(hasStore) {
      if (!hasStore) {
        await this.$store.dispatch("serieslist/fetchMatchData");
        if(this.isHtoh) {
          await this.$store.dispatch("serieslist/fetchHtohListing");
        } else {
          await this.$store.dispatch("serieslist/fetchMatchTipsListing");
        }
      }
    },
    getPaginationBaseUrl() {
      if (this.listingModules[this.pageHeadKey]) {
        let hiUrl =
          this.$route && this.$route.path && this.$route.path.includes("/hi/")
            ? "/hi/"
            : "/";
        let baseRoute = this.listingModules[this.pageHeadKey].route;
        let sportRoute =
          this.$route && this.$route.params && this.$route.params.series_slug
            ? `${this.$route.params.series_slug}`
            : "";
        return `${hiUrl}${sportRoute}${baseRoute}page/`;
      }
    },
    onPageChange(pageNum) {
      if (this.listingModules[this.pageHeadKey]) {
        let basePaginationUrl = this.getPaginationBaseUrl();
        let redirectionUrl = `${basePaginationUrl}${pageNum}`;
        if (pageNum == 1) {
          redirectionUrl = redirectionUrl.replace(`/page/${pageNum}`, "");
        }
        this.page_number = pageNum;

        this.$router.push({ path: redirectionUrl }, () => {
          let toTrack = CFG_TRACKING["22"];
          toTrack.value = this.page_number;
          toTrack.label = `page_${this.page_number}`;
          toTrack = addPagePropertiesToObject(toTrack);
          sendTrackingData(toTrack);

          window.scrollTo({ top: 0, behavior: "smooth" });
          if(this.isHtoh) {
            this.$store.dispatch("serieslist/fetchHtohListing");
          } else {
            this.$store.dispatch("serieslist/fetchMatchTipsListing");
          }
        });
      }
    },
    getcurrentSeriesObj() {
      if (this.selected_series && this.selected_series != -1) {
        return this.series_list.find(
          (s) => s.series_code === this.selected_series
        );
      } else {
        return null;
      }
    },
    getSeriesUrl(obj) {
      let url = "";
      let hiUrl =
        this.$route && this.$route.path && this.$route.path.includes("/hi/")
          ? "/hi"
          : "";
      let baseRoute = this.listingModules[this.pageHeadKey].route;
      if (obj.series_code == "-1") {
        url = CFG_MODULES.SCHEDULE.route;
      } else {
        if(obj.sport_name != null){
          let seriesName = obj.sport_name + " " + obj.category_name;
          url = `${hiUrl}/${formatString(seriesName)}-series-${obj.series_code}${baseRoute}`;
        }
      }

      if (url) {
        return urlCorrections(url);
      } else {
        return "";
      }
    },
    getPageDesc() {
      let desc = this.translations[this.pageDescKey];
      let sportName = this.sportNameLabel;
      return desc.replace(/{{sportName}}/g, sportName);
    }
  },
  beforeDestroy() {
    this.$store.unregisterModule("serieslist");
  },
};
</script>